module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/main-medium-22adf5e630efdb6d582e212b360747b1.svg";